export default __webpack_public_path__ + "static/media/797.4d2533c2.png";